export const BASE_URL = "https://akadgatepharmacy.com/backend/public/";
